import { animated, useTransition } from '@react-spring/web'

import clsx from 'clsx'

interface FadeInOutProps {
  show: boolean
  children: React.ReactNode
  className?: string
}

export const FadeInOut = ({ show, children, className }: FadeInOutProps) => {
  const transitions = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 1000 },
  })

  return transitions(
    (style, item) =>
      item && (
        <animated.div className={clsx('h-full w-full', className)} style={style}>
          {children}
        </animated.div>
      )
  )
}
